import * as ticketsApi from '../endpoints/tickets'
import { sendTelegramMessage } from '@/usabilityScripts/logsTelegram.js' // для відправки логів
import i18n from "@/i18n"; // для перекладів

export async function try_AddTicketForTesting(id, obj) {
    try {
        const response = await ticketsApi.addTicketForTesting(id, obj)
        return response.data;
    } catch (error) {
        getErrorMessage(error)
    }
}

export async function try_AddTicketForHelp(id, obj) {
    try {
        const response = await ticketsApi.addTicketForHelp(id, obj)
        return response.data;
    } catch (error) {
        getErrorMessage(error)
    }
}

function getErrorMessage(error) {
    let res = ''
    switch (error) {
        case 'data not found':
            res = i18n.global.t('dataNotFound');
            break;
        case 'ticketId not found':
            res = i18n.global.t('ticketIdNotFound');
            break;
        case 'comment is empty':
            res = i18n.global.t('dataNotFound');
            break;
        case 'ticket not found':
            res = i18n.global.t('dataNotFound');
            break;
        case 'message not sent':
            res = i18n.global.t('dataNotFound');
            break;
        default:
            res = 'An unexpected error occurred: ' + error;
    }

    // Викликаємо функцію для відправки повідомлення в телеграм
    sendTelegramMessage(res, '', '', '', '', '')
    .then(response => console.log('Telegram API response:', response.data))
    .catch(error => console.error('Telegram API error:', error));
}